import React, { useEffect, useMemo } from 'react';
import { startContent } from '../../../../constants/copyright';
import { getSelectCountryModalProps } from '../../../../constants/country';
import { safeHTML } from '../../../../utils/safeHTML';
import Volume from '../../../baseComponents/gui/volume/Volume';
import { loadMainSounds, loadOtherSounds } from '../../../../constants/sounds';
import { useApplicationCallbacks } from '../../../../providers/application-callbacks';
import { useTranslation, stores, defaultStore } from '../../../../translations';
import { useModal } from '../../../../hooks/useModal';
import SelectLangButton from '../../../features/selectLangButton/SelectLangButton';
import classNames from 'classnames';
import SelectCountryButton from '../../../features/selectCountryButton/SelectCountryButton';
import { useUser } from '../../../../redux/reducer/user';
import { useFeatureToggle } from '../../../../hooks/useFeatureToggle';
import { useLanguageControls } from '../../../../hooks/useLanguageControls';

const { button, note } = startContent;

const StartBodyButtons = React.forwardRef(function (_, ref) {
  const { t } = useTranslation();
  const { language } = useLanguageControls();
  const callbacks = useApplicationCallbacks();
  const { addModal } = useModal();
  const { profile } = useUser();
  const gameTamagotchiEnableCountrySelect = useFeatureToggle('gameTamagotchiEnableCountrySelect');
  const shouldShowCountryFeature = gameTamagotchiEnableCountrySelect;
  const isCountrySelected = Boolean(profile?.userCountry);

  const noteText = useMemo(() => {
    if (shouldShowCountryFeature && !isCountrySelected) {
      return t('countryNoteInfo.note');
    }
    return t(note);
  }, [shouldShowCountryFeature, isCountrySelected, t]);

  useEffect(() => {
    loadOtherSounds();
    loadMainSounds().then(() => callbacks.setIsSound(true));
  }, []);

  const openCountryModal = () => {
    addModal({
      type: 'selectCountryModal',
      props: {
        ...getSelectCountryModalProps({
          t,
          profile,
          language,
        }),
        isGameStopped: false,
      },
    });
  };

  const handleNoteClick = (event) => {
    if (shouldShowCountryFeature && !isCountrySelected) {
      event.stopPropagation();
      openCountryModal();
    }
    // Если страна уже выбрана или фича выключена, событие всплывет и вызовет toMain из Start.js
  };

  return (
    <>
      <div className={`start__buttons-container`}>
        <div className={'start__buttons-wrapper'}>
          <Volume
            className={classNames(
              'start__volume',
              defaultStore !== stores.ru ? 'start__volume_kz' : 'start__volume_ru',
            )}
            buttonText={t(button.text)}
            {...button}
          />
          {defaultStore !== stores.ru && <SelectLangButton isIcon className={'start__lang'} />}
        </div>
        {shouldShowCountryFeature && <SelectCountryButton isIcon className={'start__country'} />}
      </div>
      <button className={'start__note'} onClick={handleNoteClick}>
        {safeHTML(noteText)}
      </button>
    </>
  );
});
export default StartBodyButtons;
